import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import NoResults from './../components/NoResults';
import Loading from './../components/Loading';
import Filter from './../components/Filter';
import PullToRefresh from './../components/PullToRefresh';
import InstructionCard from '~shared/components/instruction-card/InstructionCard';
import BetCardContainer from '~shared/components/react/BetCardClassic/BetCardContainer';
import { filtersSet } from './../utils';

import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import isUndefined from 'lodash/isUndefined';
import { nextRepaint } from '~shared/utils/dom';

import {
    setAsGaComponent,
} from '~shared/utils/google-analytics';

import {
    BB_BETFEED_LOADING_STATES,
    BB_BETFEED_CSS_CLASS_BLOCK_NAME,
    BETFEED_YOU_BET_TEXT,
    BETFEED_YOU_AND_OTHERS_BET_TEXT,
    BETFEED_OTHERS_BET_TEXT,
    BB_BETFEED_BETCARD_ICON_CSS_CLASS_NAME,
    BB_BETFEED_GA_COMPONENT_NAME,
    BB_BETFEED_CSS_ID_PREFIX,
    BB_BETFEED_LOADING_LOADABLE_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_LOADING_LOADING_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_LOADING_LOADED_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_LOADING_NEW_BETS_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_LOADING_NEW_BETS_TEXT,
    BB_BETFEED_LOADING_NEW_BETS_FIXED_CSS_CLASS_NAME,
    BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHTLIGHT_DELAY,
    BB_BETFEED_NUMBER_OF_PEOPLE_BET_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHLIGHT_CSS_CLASS_NAME_IDENTIFIER,
    BB_BETFEED_FOOTER_JS_CSS_PREFIX,
    BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHLIGHT_COLOR_GREEN_IDENTIFIER,
    BB_BETFEED_PULL_REFRESH_CSS_BLOCK_NAME,
    GTM_BETFEED_PAGE,
    INSTRUCTION_CONTENT_PAGE,
    INSTRUCTION_CONTENT_TITLE,
    BETFEED_BET_CARD_GTM,
    BB_BETFEED_FILTER_TYPE_SORT_BY,
    BB_BETFEED_FILTER_TYPE_SPORTS,
    BB_BETFEED_FILTER_TYPE_BET_TYPE,
    BB_BETFEED_FILTER_DEBOUNCE,
    BB_BETFEED_FILTER_QUERY_KEY,
    BB_BETFEED_FILTER_MOST_RECENT,
    BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
} from './../../constants';

import {
    BETFEED_INSTRUCTION_CARD,
} from '~shared/components/instruction-card/constants/constants';

import {
    BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER,
} from '~shared/components/react/BetCardClassic/constants';

import {
    scrollToTop,
    elementIsFullyVisible,
} from '~shared/utils/win';

import {
    WRAPPER_CSS_ID as BREADCRUMBS_CSS_ID,
} from '~spa/Components/Breadcrumbs/constants';

import * as betfeedActions from './../actions/betfeedActions';

import { createEventEmitter } from '~shared/utils/event';

export class BetFeedContainer extends React.Component {

    constructor(props) {
        super(props);
        this._constructor(props);
    }

    _constructor() {
        this.bindBetfeedEl = this.bindBetfeedEl.bind(this);
        this.wsEventListener = this.wsEventListener.bind(this);
        this.wsEventListenerNumberOfPeopleBets = this.wsEventListenerNumberOfPeopleBets.bind(this);
        this.reLoadForNewBets = this.reLoadForNewBets.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.clearFiltersHandler = this.clearFiltersHandler.bind(this);
        this.ev = createEventEmitter();
        this.stopListeningForWsUpdates = this.stopListeningForWsUpdates.bind(this);
    }

    static propTypes = {
        betCards: PropTypes.array,
        loadingState: PropTypes.string,
        dispatch: PropTypes.func,
        updateCommonStoreWsData: PropTypes.func,
        updateNumberOfPeopleBetsWsData: PropTypes.func,
        getBetCards: PropTypes.func,
        commonDataEvents: PropTypes.object,
        betcard_id: PropTypes.number,
        isNewBets: PropTypes.bool,
        errorOccurred: PropTypes.bool,
        filter: PropTypes.object.isRequired,
        resetFilters: PropTypes.func.isRequired,
        activeFilter: PropTypes.func,
        selectFilterOption: PropTypes.func,
        betfeedLoading: PropTypes.func,
        getSportFilter: PropTypes.func,
        stopListeningForWsUpdates: PropTypes.func,
        stopListeningForWsNumberOfPeopleBettedUpdates: PropTypes.func,
    }

    betcardFooterRenderObject = {
        icon_block_css_id: '',
        icon_block_css_class: '',
        icon_background_css_class: BB_BETFEED_BETCARD_ICON_CSS_CLASS_NAME,
        text_block_css_id: '',
        text_block_css_class: '',
        text_should_update: ({ betcard: nextBetcard }, { betcard }) => {
            if (nextBetcard.backing_customers !== betcard.backing_customers) {
                return true;
            }

            return false;
        },
        text_block_html: (footerProps) => {
            const jsCssId = `${BB_BETFEED_FOOTER_JS_CSS_PREFIX}-${footerProps.betcard.betcard_id}`;

            const numberOfPeopleBetEl = document.getElementById(jsCssId);
            const textHighLightEl = document.querySelectorAll(`#${jsCssId} .${BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER}`);

            const removeFlashHighLight = () => {
                nextRepaint(() => {
                    numberOfPeopleBetEl.classList.remove(BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHLIGHT_CSS_CLASS_NAME_IDENTIFIER);
                    textHighLightEl.forEach(el => {
                        el.classList.remove(BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHLIGHT_COLOR_GREEN_IDENTIFIER);
                    });
                });
            };

            const addFlashHighLight = () => {
                nextRepaint(() => {
                    numberOfPeopleBetEl.classList.add(BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHLIGHT_CSS_CLASS_NAME_IDENTIFIER);
                    textHighLightEl.forEach(el => {
                        el.classList.add(BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHLIGHT_COLOR_GREEN_IDENTIFIER);
                    });
                    setTimeout(removeFlashHighLight, BB_BETFEED_NUMBER_OF_PEOPLE_BET_HIGHTLIGHT_DELAY);
                });
            };

            if (numberOfPeopleBetEl && textHighLightEl.length) {
                addFlashHighLight();
            }

            const one = 1;
            const { user_included: userIncluded, backing_customers: userCount } = footerProps.betcard;
            const otherUserCount = userIncluded ? userCount - one : userCount;

            return (
                <span id={jsCssId} className={BB_BETFEED_NUMBER_OF_PEOPLE_BET_CSS_CLASS_BLOCK_NAME}>
                    {Boolean(userIncluded) && !(otherUserCount)
                        &&
                        <Trans i18nKey={BETFEED_YOU_BET_TEXT}>
                            <span className={BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER}>You</span> bet on this
                        </Trans>
                    }
                    {Boolean(userIncluded) && Boolean(otherUserCount)
                        &&
                        <Trans i18nKey={BETFEED_YOU_AND_OTHERS_BET_TEXT} count={otherUserCount}>
                            <span className={BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER}>You</span> and
                            <span className={BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER}>x</span> other person(s) bet on this
                        </Trans>

                    }
                    {!userIncluded && Boolean(userCount)
                        &&
                        <Trans i18nKey={BETFEED_OTHERS_BET_TEXT} count={userCount}>
                            <span className={BB_BETCARD_COLOR_TEXT_BLUE_CSS_CLASS_NAME_MODIFIER}>x</span> person(s) bet on this
                        </Trans>
                    }
                </span>
            );
        },
    }

    /**
     * Retrieves the Event (and nested markets and selections) from the common data store
     * to pass to the BetCardContainer.
     * @param {Object} betcard the betcard
     * @returns {Object} the event object, with all nested markets and selections
     */
    getBetcardEventTree(betcard) {
        const eventMarkets = {};
        betcard.selection_pointers.forEach(ptr => {
            if (isEmpty(eventMarkets[ptr.event_id])) {
                const eventMarket = this.props.commonDataEvents[ptr.event_id];
                if(!isUndefined(eventMarket)) {
                    eventMarkets[ptr.event_id] = eventMarket;
                }
            }
        });

        return eventMarkets;
    }

    getQueryParams() {
        try {
            const params = JSON.parse(
                localStorage.getItem(BB_BETFEED_FILTER_QUERY_KEY)
            );

            return this.checkQueryParams(params);

        } catch(e) {
            return {};
        }
    }

    /**
     * Check query params to make sure they have not been edited in the local storage
     * @param {object} params Object with the query paramteres
     * @returns {object} The query params
     */
    checkQueryParams(params) {
        if (params) {
            const regexSortType = /^[a-z_]*$/;
            const regexSport = /^[a-z0-9-]*$/;
            const { id: sortBy } = BB_BETFEED_FILTER_TYPE_SORT_BY;
            const { id: sport } = BB_BETFEED_FILTER_TYPE_SPORTS;
            const { id: betType } = BB_BETFEED_FILTER_TYPE_BET_TYPE;

            if (params[sortBy]) {
                if (!regexSortType.test(params[sortBy].id)) {
                    // Give it the default value
                    params[sortBy] = BB_BETFEED_FILTER_MOST_RECENT;
                }
            }

            if (params[sport]) {
                if (!regexSport.test(params[sport])) {
                    params[sport] = '';
                }
            }

            if (params[betType]) {
                this.props.selectFilterOption(betType, params[betType].id);
                if (!regexSortType.test(params[betType].id)) {
                    // Give it the default value
                    params[betType] = BB_BETFEED_FILTER_BET_TYPES_DEFAULT;
                }
            }
        }

        return params;
    }

    removeQueryParams() {
        localStorage.removeItem(BB_BETFEED_FILTER_QUERY_KEY);
    }

    wsEventListener(wsData) {
        this.props.updateCommonStoreWsData(wsData);
    }

    stopListeningForWsUpdates(wsData) {
        this.props.stopListeningForWsUpdates(wsData);
        this.props.stopListeningForWsNumberOfPeopleBettedUpdates(wsData);
    }

    wsEventListenerNumberOfPeopleBets(wsData) {
        this.props.updateNumberOfPeopleBetsWsData(wsData);
    }

    componentDidMount() {
        this.props.getSportFilter();
        const {
            filter: {
                filters: { sports },
            },
        } = this.props;
        if(!isEmpty(sports)){
            this.refreshBetsFromParams();
        }
        setAsGaComponent(this.betfeedEl, BB_BETFEED_GA_COMPONENT_NAME);
        window.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const {
            isNewBets: prevIsNewBets,
            filter: {
                filters: { sports: prevSports },
            },
        } = prevProps;
        const {
            isNewBets,
            filter: {
                filters: { sports },
            },
        } = this.props;

        if (prevIsNewBets !== isNewBets) {
            this.handleLoadingIcons();
        }

        if(!isEqual(prevSports, sports)){
            this.refreshBetsFromParams();
        }
    }

    componentWillUnmount() {
        if (this.props.betCards && this.props.betCards.length) {
            this.stopListeningForWsUpdates(this.props.betCards);
        }
    }

    refreshBetsFromParams() {
        const haveParamsFilters = this.applyFiltersFromParams();
        if(!haveParamsFilters) {
            this.refreshBets(true);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
    }

    bindBetfeedEl(element) {
        this.betfeedEl = element;
    }

    reLoadForNewBets() {
        this.refreshBets(true);
        scrollToTop();
    }

    handleScroll() {
        this.handleLoadingIcons();
    }

    handleLoadingIcons() {
        nextRepaint(() => {
            const breadScrumEl = document.getElementById(BREADCRUMBS_CSS_ID);
            const loadingEl = document.querySelector(`.${BB_BETFEED_LOADING_NEW_BETS_CSS_CLASS_BLOCK_NAME}`);

            if (!isEmpty(breadScrumEl)) {
                if (loadingEl && elementIsFullyVisible(breadScrumEl)) {
                    loadingEl.classList.remove(BB_BETFEED_LOADING_NEW_BETS_FIXED_CSS_CLASS_NAME);
                } else if (loadingEl) {
                    loadingEl.classList.add(BB_BETFEED_LOADING_NEW_BETS_FIXED_CSS_CLASS_NAME);
                }
            }
        });
    }

    applyFiltersFromParams() {
        const refresh = debounce(() => this.refreshBets(true), BB_BETFEED_FILTER_DEBOUNCE);
        const params = this.getQueryParams();
        let hasParams = false;

        if (params) {
            const { id: sortBy } = BB_BETFEED_FILTER_TYPE_SORT_BY;
            const { id: sport } = BB_BETFEED_FILTER_TYPE_SPORTS;
            const { id: betType } = BB_BETFEED_FILTER_TYPE_BET_TYPE;

            if (params[sortBy]) {
                this.props.selectFilterOption(sortBy, params[sortBy].id);
                hasParams = true;
            }
            if (params[sport]) {
                this.props.resetFilters(sport);
                this.props.selectFilterOption(sport, params[sport]);
                hasParams = true;
            }
            if (params[betType]) {
                this.props.selectFilterOption(betType, params[betType].id);
                hasParams = true;
            }
            if(hasParams){
                refresh();
            }

            // Only need them on first landing of page
            this.removeQueryParams();
        }

        return hasParams;
    }

    async refreshBets(fromBE) {
        this.props.betfeedLoading(BB_BETFEED_LOADING_STATES.LOADING);
        if (fromBE) {
            await this.props.getBetCards(this.wsEventListener, this.wsEventListenerNumberOfPeopleBets);
        } else {
            const waitMs = 500;
            await new Promise(resolve => setTimeout(() => {
                resolve();
            }, waitMs));
        }
        this.refreshBets.fetched = true;
        this.props.betfeedLoading(BB_BETFEED_LOADING_STATES.LOADED);
    }


    loadingProps() {
        const loadingProps = {
            cssLoadingBackground: '',
            cssLoadingIcon: '',
            loadingText: '',
            reLoadForNewBets: () => false,
        };
        const { LOADABLE, LOADING, LOADED } = BB_BETFEED_LOADING_STATES;

        if (this.props.isNewBets) {
            loadingProps.cssLoadingBackground = `${BB_BETFEED_LOADING_NEW_BETS_CSS_CLASS_BLOCK_NAME} `;
            loadingProps.loadingText = BB_BETFEED_LOADING_NEW_BETS_TEXT;
            loadingProps.reLoadForNewBets = this.reLoadForNewBets;
        }

        switch (this.props.loadingState) {
            case LOADABLE: {
                loadingProps.cssLoadingBackground += `${BB_BETFEED_LOADING_LOADABLE_CSS_CLASS_BLOCK_NAME}`;
                loadingProps.loadingText = '';
                break;
            }
            case LOADING: {
                loadingProps.cssLoadingBackground += `${BB_BETFEED_LOADING_LOADING_CSS_CLASS_BLOCK_NAME}`;
                break;
            }
            case LOADED: {
                loadingProps.cssLoadingBackground += `${BB_BETFEED_LOADING_LOADED_CSS_CLASS_BLOCK_NAME}`;
                break;
            }
            default:
        }

        return loadingProps;
    }

pullToRefreshProps() {
        const { LOADABLE, LOADED } = BB_BETFEED_LOADING_STATES;

        return {
            state: this.props.loadingState,
            pullArea: {
                selector: `.${BB_BETFEED_PULL_REFRESH_CSS_BLOCK_NAME}`,
            },
            actions: {
                pulling: loadable => {
                    const loadingState = loadable ? LOADABLE : LOADED;
                    if (this.props.loadingState !== loadingState) {
                        this.props.betfeedLoading(loadingState);
                    }
                },
                refresh: () => this.refreshBets(this.props.isNewBets),
            },
        };
    }

    clearFiltersHandler(filter) {
        this.props.resetFilters(filter);
        this.refreshBets(true);
    }

    betfeedInstructionCard() {
        const instructionContent = <Trans>{INSTRUCTION_CONTENT_PAGE}</Trans>;
        const instructionTitle = <Trans>{INSTRUCTION_CONTENT_TITLE}</Trans>;

        return (
            <InstructionCard
                type={BETFEED_INSTRUCTION_CARD}
                contentText={instructionContent}
                titleText={instructionTitle}
                gtmAttribute={`${GTM_BETFEED_PAGE};${BETFEED_BET_CARD_GTM};`}
                pageMode={true}
            />
        );
    }

    render() {
        // add fetched for not displaying NoResult at first fetching
        const noResults = !this.props.betCards.length && this.refreshBets.fetched;
        const filtersAreSet = filtersSet(this.props.filter.selected);
        const {
            filter: {
                selected: {
                    sortBy: {
                        id: sortBy,
                    },
                },
            },
         } = this.props;

        return (
            <div>
                <Filter {...this.props.filter}
                    refreshBets={this.refreshBets.bind(this, true)}
                    activeFilter={this.props.activeFilter}
                    selectFilterOption={this.props.selectFilterOption}
                    clearFiltersHandler={this.clearFiltersHandler}
                    gtmAttribute={GTM_BETFEED_PAGE} />
                <PullToRefresh {...this.pullToRefreshProps()}>
                    <div className={BB_BETFEED_CSS_CLASS_BLOCK_NAME} ref={this.bindBetfeedEl}>
                        <Loading {...this.loadingProps()} />
                        {this.betfeedInstructionCard()}
                        {this.props.betCards.map((betcard, index) =>
                                    <BetCardContainer
                                        key={betcard.betcard_id}
                                        betcard={{...betcard, position: index }}
                                        footerType={sortBy}
                                        commonDataEvents={this.getBetcardEventTree(betcard)}
                                        gaComponent={BB_BETFEED_GA_COMPONENT_NAME}
                                        cssIdPrefix={BB_BETFEED_CSS_ID_PREFIX}
                                        gtmAttribute={GTM_BETFEED_PAGE}
                                    />
                        )}
                        {(this.props.errorOccurred || noResults) &&
                            <NoResults filtersSet={filtersAreSet} buttonClickHandler={this.clearFiltersHandler} />
                        }
                    </div>
                </PullToRefresh>
            </div>
        );
    }

}

/**
 * React-redux bindings
 * @param {*} state the current state
 * @returns {object} props
 */
function mapStateToProps(state) {
    return {
        betCards: state.betcards.betCards,
        loadingState: state.betcards.loadingState,
        isNewBets: state.betcards.isNewBets,
        filter: state.betcards.filter,
        errorOccurred: state.betcards.errorOccurred,
        commonDataEvents: state.commonData,
    };
}

/**
 * React-redux bindings
 * @param {*} dispatch the dispatcher function
 * @returns {object} betfeed actions
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(betfeedActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BetFeedContainer);
